import 'script-loader!jquery/dist/jquery.slim.min.js';
import './lib/local-storage-polyfill';

// recursively import all scripts and styles
const context = require.context('.', true, /\.(js|css|scss)$/);
context.keys().forEach(context);



// WEBPACK FOOTER //
// ./src/portal/index.js